import { api } from '@/modules/helper';

export default {
  namespaced: true,

  state: {},

  mutations: {},

  getters: {},

  actions: {
    customer() {
      return api
        .get('statistic/customer')
        .then(({ data }) => data)
        .catch(error => error);
    },

    media() {
      return api
        .get('statistic/media')
        .then(({ data }) => data)
        .catch(error => error);
    },
  },
};
